import React, { useMemo, useState } from 'react';
import { Col, Row } from 'tea-component';
import { getLocale } from 'umi';
import GameStore from '../GameStore';
import CommunityPerformance from '../CommunityPerformance';
import LanguageChannel from '../LanguageChannel';
import OfficialAccounts from '../OfficialAccounts';
import Influencers from '../Influencers';
import PR from '../PR';
import GoogleTrends from '../GoogleTrends';
import KeywordHotEvent from '../KeywordHotEvent';
import RangePicker from '@/pages/home/components/RangePicker';
import FullScreenBtn from '../../components/FullScreenBtn';
import { useStudioFullscreen } from '../../components/StudioFullscreen/context';
import moment from 'moment';
import './index.scss';

function formatTime(value: [moment.Moment, moment.Moment]) {
  return [
    value[0].startOf('d').format('YYYY-MM-DD HH:mm:ss'),
    value[1].endOf('d').format('YYYY-MM-DD HH:mm:ss'),
  ];
}

export default function OpinionsStudio({ gameInfo }: { gameInfo: any; }) {
  const [timeValue, setTimeValue] = useState<[moment.Moment, moment.Moment]>(
    [moment().subtract(6, 'd'), moment()],
  );
  const [isConfirm, setIsConfirm] = useState(false);
  const isFullscreen = useStudioFullscreen()?.isFullscreen ?? false;

  const filter = useMemo(() => {
    const timeVal = formatTime(timeValue);
    return {
      ...gameInfo,
      start_time: timeVal[0],
      end_time: timeVal[1],
      date_type: 'daily',
      isConfirm,
    };
  }, [gameInfo, timeValue]);

  return (
    <FullScreenBtn className="dbh-opinions-studio-fullscreen">
      <div className="dbh-ingame-analytics">
        <div className="dbh-studio-operate">
          <div className="search-item search-item-date">
            <RangePicker
              type="date"
              value={timeValue}
              className="search-border"
              typeList={['date']}
              language={getLocale() === 'zh-CN' ? 'cn' : 'en'}
              showSelectType={false}
              startOfWeek={0}
              onChange={(value: any) => {
                setTimeValue(value);
                setIsConfirm(true);
              }}
            />
          </div>
        </div>
        <Row className="dbh-opinions-row dbh-opinions-row--overview">
          <Col span={15}>
            <GameStore filter={filter} isFullscreen={isFullscreen}/>
          </Col>
          <Col span={9}>
            <CommunityPerformance filter={filter} tooltipMaxTop={isFullscreen ? 150 : 340} />
          </Col>
        </Row>

        <Row className="dbh-opinions-row dbh-opinions-row--insights">
          <Col span={15}>
            <KeywordHotEvent filter={filter} />
          </Col>
          <Col span={9}>
            <LanguageChannel
              filter={filter}
              config={{className: 'dbh-opinions-studio-language-channel', stateHeight: 165}}
            />
          </Col>
        </Row>

        <Row className="dbh-opinions-row dbh-opinions-row--channels">
          <Col span={6}>
            <OfficialAccounts key={gameInfo?.edition_unified_id} filter={filter}/>
          </Col>
          <Col span={6}>
            <Influencers filter={filter}></Influencers>
          </Col>
          <Col span={6}>
            <PR filter={filter}></PR>
          </Col>
          <Col span={6}>
            <GoogleTrends filter={filter}></GoogleTrends>
          </Col>
        </Row>
      </div>
    </FullScreenBtn>
  );
}
